import React, { Fragment } from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function MotorcycleSlide() {
  const steps = [{
    step: 1,
    label: 'Add New Bike',
    image: 'https://cdn.magicpatterns.com/uploads/o67vgXwkKCBenKfGFo8Lct/Step1.png',
    highlight: false
  }, {
    step: 2,
    label: 'Enter Vehicle Details',
    image: 'https://cdn.magicpatterns.com/uploads/cg3CGb5Xz7M1MxuwithRTD/Step2.png',
    highlight: false
  }, {
    step: 3,
    label: 'UAE Pass Verification',
    image: 'https://cdn.magicpatterns.com/uploads/gB2qKhKx7k4eXtcFwA6nNS/Step3.png',
    highlight: true
  }, {
    step: 4,
    label: 'Document Signed',
    image: 'https://cdn.magicpatterns.com/uploads/vZo1EqW9eHLq2jZAs7PtVK/Step4.png',
    highlight: true
  }, {
    step: 5,
    label: 'Motorcycle Linked',
    image: 'https://cdn.magicpatterns.com/uploads/v7vT3Q4ytKKp88zAnzQtEX/Step5.png',
    highlight: false
  }];
  return <div className="flex flex-col w-screen h-screen overflow-hidden bg-white text-[#1a1a2e] px-6 py-4" data-id="element-284">
      {/* Top Header */}
      <div className="flex justify-between items-start shrink-0" data-id="element-285">
        <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-8 w-auto object-contain" data-id="element-286" />
      </div>

      {/* Title — compact */}
      <div className="text-center shrink-0 mb-1" data-id="element-287">
        <span className="text-xs font-semibold text-[#2EBCB0] uppercase tracking-widest" data-id="element-288">
          Vehicle Activation
        </span>
        <h1 className="text-[1.25rem] font-bold text-[#1a1a2e] mt-0.5" data-id="element-289">
          Motorcycle Activation Process
        </h1>
        <p className="text-[0.75rem] text-gray-500 mt-1 max-w-2xl mx-auto leading-snug" data-id="element-290">
          Drivers activate and securely link their motorcycles through a fully
          digital and verified process.
        </p>
      </div>

      {/* Main Flow — 5 screenshots */}
      <div className="flex-grow flex items-center justify-center gap-2 px-1 w-full" data-id="element-291">
        {steps.map((step, idx) => <Fragment key={idx} data-id="element-292">
            <div className="flex flex-col items-center flex-1 min-w-0" data-id="element-293">
              {/* Step Number */}
              <div className="w-6 h-6 rounded-full flex items-center justify-center text-[0.65rem] font-bold mb-1.5 bg-[#2EBCB0] text-white" data-id="element-294">
                {step.step}
              </div>

              {/* Screenshot */}
              <div className="w-full rounded-xl overflow-hidden mb-1.5" data-id="element-295">
                <img src={step.image} alt={step.label} className="w-full h-auto object-contain" data-id="element-296" />
              </div>

              {/* Label */}
              <h3 className="font-bold text-[0.7rem] text-[#1a1a2e] text-center leading-tight" data-id="element-297">
                {step.label}
              </h3>
            </div>

            {/* Arrow between steps */}
            {idx < steps.length - 1 && <div className="shrink-0 flex items-center px-0.5 -mt-8" data-id="element-298">
                <ArrowRightIcon className="w-4 h-4 text-[#2EBCB0]/50" data-id="element-299" />
              </div>}
          </Fragment>)}
      </div>

      {/* Bottom Tagline */}
      <div className="text-center shrink-0" data-id="element-300">
        <p className="text-[0.75rem] italic text-gray-400" data-id="element-301">
          "Secure vehicle registration through verified digital identity and UAE
          Pass."
        </p>
      </div>
    </div>;
}